<template>
  <div style="width: 100%;height: 100vh;display: flex;justify-content: center;align-items: center;">
    <el-empty description="404"></el-empty>
  </div>
</template>

<script>
export default {
  name: 'notFoundPage'
}
</script>

<style scoped>

</style>
